/**
 * frontend/src/modules/referentials/hooks/useRefBrands.ts
 * Liste complète des marques pour la page Brands + filtres.
 * queryKey partagé avec useFlashInfoBrands (DECISIONS #100).
 * Phase 4.I.8 · DECISIONS #101
 */
import { useQuery } from '@tanstack/react-query';
import { fetchBrandsList } from '../lib/api';

export function useRefBrands() {
  return useQuery({
    queryKey: ['referentials', 'brands'] as const,
    queryFn: fetchBrandsList,
    staleTime: 5 * 60 * 1000,
  });
}
